import { render, staticRenderFns } from "./WeAreWorking.vue?vue&type=template&id=4ef7aa58&"
import script from "./WeAreWorking.vue?vue&type=script&lang=js&"
export * from "./WeAreWorking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports